import React from 'react';

const items = [
    '10th & 12th Marksheets',
    'NEET Scorecard',
    'Valid Passport',
    'Passport-sized Photos',
    'Birth Certificate',
    'Medical Fitness Certificate',
    'Police Clearance Certificate',
    'Bank Statement',
    'IELTS/TOEFL (if required)'
];

export default function DocumentsReady() {
    return (
        <section className="relative overflow-hidden bg-gradient-to-b from-[#FFF7F0] via-[#fffaf5] to-white">
            <div className="absolute left-0 top-0 h-72 w-72 -translate-x-1/3 -translate-y-1/3 rounded-full bg-[#ff9245]/10 blur-3xl" />
            <div className="absolute bottom-0 right-0 h-80 w-80 translate-x-1/3 translate-y-1/3 rounded-full bg-[#1c2d44]/5 blur-3xl" />

            <div className="relative z-10 mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
                <div className="mx-auto mb-8 max-w-3xl text-center sm:mb-10">
                    <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
                        Get your Documents Ready, <span className='text-[#ff9245]'>We’ll Handle the Rest</span>
                    </h2>
                    <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-600 md:mt-4 md:text-base">
                        Just have these key documents in place, we’ll manage everything from filing to university submissions.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
                    {items.map((title, i) => (
                        <div key={i} className="w-full">
                            <div className="flex items-center gap-3 rounded-2xl border border-[#ffe2cf] bg-white px-4 py-3 shadow-[0_12px_30px_rgba(15,23,42,0.06)] transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-[0_16px_36px_rgba(15,23,42,0.08)] sm:gap-4 sm:px-5 sm:py-4">
                                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-[#fff4eb] text-xl shadow-inner shadow-white/60 sm:h-12 sm:w-12 sm:text-2xl">
                                    {getIconFor(title)}
                                </div>
                                <div className="text-sm font-semibold leading-snug text-slate-800 sm:text-[15px] md:text-base">{title}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function getIconFor(title) {
    if (title.toLowerCase().includes('passport')) return '🛂';
    if (title.toLowerCase().includes('marks')) return '📄';
    if (title.toLowerCase().includes('photos')) return '📷';
    if (title.toLowerCase().includes('neET'.toLowerCase())) return '📝';
    if (title.toLowerCase().includes('birth')) return '📕';
    if (title.toLowerCase().includes('medical')) return '🩺';
    if (title.toLowerCase().includes('police')) return '🔒';
    if (title.toLowerCase().includes('bank')) return '🏦';
    return '📎';
}
